export default __webpack_public_path__ + "locales/ro/JavascriptSdk.json?hash=e10b4fbfd90001e17450f232e16c5e9f";